import SchoolAccessRetrieval from './SchoolAccessRetrieval'

export default SchoolAccessRetrieval
